import type { PlatformApiClient } from "../../api";
import { CampaignDispatchReadinessPanel } from "./CampaignDispatchReadinessPanel";

/** Read-only acquisition context. Result attribution has no certified source yet. */
export function AcquisitionResultsReport({
  slug, api, base, navigate, onExpired,
}: {
  slug: string;
  api: PlatformApiClient;
  base: string;
  navigate: (path: string) => void;
  onExpired: () => void;
}) {
  const acquisitionPath = `${base}/acquisition`;
  return (
    <div className="rep-acquisition-results" role="region" aria-label="Reportes de Captación">
      <section className="details-card rep-acquisition-results-intro">
        <p className="eyebrow">Captación de reseñas</p>
        <h2>Resultados de invitaciones</h2>
        <p>Los reportes de atención y captación son procesos distintos. Aún no existe
          una fuente certificada para atribuir reseñas de Google a una campaña.
          Las entregas y los clics informados por proveedor se muestran en el estado operativo cuando hay recibos verificables.</p>
        <a href={acquisitionPath} className="rep-acquisition-report-link"
          onClick={event => { event.preventDefault(); navigate(acquisitionPath); }}>
          Ir a Captación →
        </a>
      </section>

      <div className="rep-acquisition-results-grid" aria-label="Métricas de resultado pendientes de fuente">
        <div className="rep-acquisition-results-metric">
          <span>Invitaciones enviadas</span>
          <strong>No disponible</strong>

        </div>
        <div className="rep-acquisition-results-metric">
          <span>Entregas confirmadas</span>
          <strong>No disponible</strong>

        </div>
        <div className="rep-acquisition-results-metric">
          <span>Clics registrados</span>
          <strong>No disponible</strong>

        </div>
        <div className="rep-acquisition-results-metric">
          <span>Reseñas atribuibles</span>
          <strong>No disponible</strong>

        </div>
      </div>
      <details className="rep-acquisition-results-methodology">
        <summary>Por qué faltan estas métricas</summary>
        <ul>
          <li><strong>Enviadas:</strong> el diagnóstico de colas no acredita envíos confirmados en un período.</li>
          <li><strong>Entregadas:</strong> el estado operativo consulta recibos del proveedor acumulados, sin filtro de período.</li>
          <li><strong>Clics:</strong> los recibos del proveedor pueden incluir verificadores automáticos, no sólo personas.</li>
          <li><strong>Reseñas:</strong> abrir un enlace no demuestra publicación en Google ni atribución a la campaña.</li>
        </ul>
      </details>

      <div className="rep-acquisition-results-operational">
        <h2>Estado operativo actual</h2>
        <p>La siguiente consulta es una instantánea de preparación de colas,
          <strong> no un resultado del período</strong>. «En cola», «con horario vencido» y
          «aceptadas por proveedor» no significan entregadas ni autorizan envíos.</p>
        <CampaignDispatchReadinessPanel slug={slug} api={api} onExpired={onExpired} />
      </div>
      <p className="rep-acquisition-results-method">
        Fuente: diagnóstico tenant-scoped en modo solo lectura. El período de Atención
        no se aplica a esta instantánea. No se envían mensajes desde Reportes.
      </p>
    </div>
  );
}
